export const MOBILE_NET_INPUT_WIDTH = 224
export const MOBILE_NET_INPUT_HEIGHT = 224

export const MOBILENET_URL =
  "https://tfhub.dev/google/tfjs-model/imagenet/mobilenet_v3_small_100_224/feature_vector/5/default/1"